<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ title }}</h2>
      <p class="text-muted mb-0">{{ description }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    @if (currentImageUrl) {
      <div class="row mb-4">
        <div class="col-12">
          <label class="form-label">Current Image</label>
          <div class="mb-3">
            <img
              [src]="currentImageUrl"
              alt="Current image"
              [style.max-width]="imageType === 'header' ? '100%' : '300px'"
              [style.max-height]="imageType === 'header' ? '200px' : '300px'"
              style="object-fit: cover; border-radius: 8px; border: 1px solid #e4e6ef;"
            />
          </div>
        </div>
      </div>
    }

    @if (!showCropSelector) {
      <div class="row">
        <div class="col-12">
          <label class="form-label">New Image</label>
          <app-fileorini
            [accept]="'image/*'"
            (filesChanged)="onFileSelected($event[0])"
          />
        </div>
      </div>
    }

    @if (showCropSelector && originalFile) {
      <div class="row">
        <div class="col-12">
          <label class="form-label mb-3">Position your image</label>
          <p class="text-muted small mb-3">
            @if (imageType === 'header') {
              Drag the selection box to choose which part of your image will be displayed in the header.
            } @else {
              Drag the selection box to choose which part of your image will be displayed as the logo.
            }
          </p>
          <app-image-crop-selector
            [imageSource]="originalFile"
            [aspectRatio]="cropAspectRatio"
            [generateBase64]="true"
            (cropConfirmed)="onCropConfirmed($event)"
            (cancelled)="onCropCancelled()"
          />
        </div>
      </div>
    }
  </div>

  @if (!showCropSelector) {
    <div class="modal-footer">
      <div class="row w-100">
        <div class="col-12 d-flex justify-content-end gap-2">
          <app-button
            [variant]="'neutral'"
            [label]="'Cancel'"
            (clicked)="close()"
          />
          <app-button
            [variant]="'primary'"
            [label]="'Upload'"
            [iconClass]="'fa fa-upload'"
            [disabled]="!selectedFile"
            [loading]="uploading"
            (clicked)="onSave()"
          />
        </div>
      </div>
    </div>
  }
</div>
